var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component } from "vue-facing-decorator";
import { State, Action } from "vuex-facing-decorator";
import { BackgroundTasksState } from "@/app/store/modules/background-tasks.state";
/**
 * Shows and hides the Background tasks panel. Hidden when the user has no tasks. The badge counts
 * tasks queued or running, and turns red while a task that finished with problems has not been looked
 * at. Generic: it knows nothing about what the tasks do.
 */
let BackgroundTasksIndicator = class BackgroundTasksIndicator extends Vue {
    /** Running tasks first; otherwise the problems waiting to be seen; nothing when all is quiet. */
    get badge() {
        if (this.tasks.activeCount > 0)
            return this.tasks.activeCount;
        if (this.tasks.problemCount > 0)
            return this.tasks.problemCount;
        return null;
    }
    get title() {
        const parts = [];
        if (this.tasks.activeCount > 0)
            parts.push(`${this.tasks.activeCount} running`);
        if (this.tasks.problemCount > 0)
            parts.push(`${this.tasks.problemCount} finished with problems`);
        const summary = parts.length ? ` (${parts.join(", ")})` : "";
        return `Background tasks${summary}: click to ${this.tasks.panelOpen ? "hide" : "show"}`;
    }
};
__decorate([
    State("backgroundTasksModule"),
    __metadata("design:type", typeof (_a = typeof BackgroundTasksState !== "undefined" && BackgroundTasksState) === "function" ? _a : Object)
], BackgroundTasksIndicator.prototype, "tasks", void 0);
__decorate([
    Action("togglePanel", { namespace: "backgroundTasksModule" }),
    __metadata("design:type", Object)
], BackgroundTasksIndicator.prototype, "togglePanel", void 0);
BackgroundTasksIndicator = __decorate([
    Component({ name: "BackgroundTasksIndicator" })
], BackgroundTasksIndicator);
export default BackgroundTasksIndicator;
